import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Mail, Loader2, Zap, CheckCircle, ArrowRight, Users } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PromoterLogin() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setError("");
    if (!email.includes("@")) { setError("Valid email required"); return; }
    setSubmitting(true);
    try { await axios.post(`${API}/promoter/auth/request-link`, { email }); setSent(true); }
    catch (err) { setError(err.response?.data?.detail || "Could not send link"); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-4" data-testid="promoter-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-6 font-extrabold text-zinc-950">
          <div className="w-8 h-8 bg-zinc-950 rounded-lg flex items-center justify-center"><Zap size={16} className="text-white" /></div>
          FastPrototype.ai
        </Link>
        <div className="bg-white border border-zinc-200 rounded-3xl p-8">
          <div className="flex items-center gap-2 mb-3">
            <Users size={18} className="text-zinc-700" />
            <h1 className="font-bold text-zinc-950 text-lg">Promoter Dashboard</h1>
          </div>
          {sent ? (
            <div className="text-center py-6" data-testid="promoter-login-sent">
              <CheckCircle size={28} className="text-emerald-600 mx-auto mb-3" />
              <p className="text-sm text-zinc-700">If your email is registered, we've sent a magic link that's valid for 15 minutes.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-3" data-testid="promoter-login-form">
              <p className="text-sm text-zinc-600">Enter the email you registered with. We'll email you a one-click link to your dashboard.</p>
              <div className="relative">
                <Mail size={14} className="absolute left-3 top-3.5 text-zinc-400" />
                <input required type="email" data-testid="input-promoter-email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com" autoFocus
                  className="w-full pl-9 pr-3 py-2.5 bg-zinc-50 border border-zinc-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-zinc-900" />
              </div>
              {error && <div data-testid="promoter-login-error" className="text-xs text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</div>}
              <button type="submit" disabled={submitting} data-testid="btn-promoter-send-link"
                className="w-full py-3 bg-zinc-950 text-white rounded-full font-semibold text-sm hover:bg-zinc-800 disabled:opacity-50 inline-flex items-center justify-center gap-2">
                {submitting ? <><Loader2 size={14} className="animate-spin" /> Sending…</> : <>Send me a magic link <ArrowRight size={14} /></>}
              </button>
              <p className="text-[11px] text-zinc-400 text-center">Not a promoter yet? <Link to="/about" className="underline">Learn about our 15% commission program</Link></p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
